/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { PreFooterProps } from './index';

/**
 * Base styles for the pre footer component
 *
 * @param {PreFooterProps} props The pre footer properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: PreFooterProps) => css`
    .pre-footer {
        padding: 4.8rem 0;
        border-top: 0.1rem solid var(--colors-border-light);
    }

    ${smallTablet(css`
        display: none;
    `)}
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The pre footer component styles
 *
 * @param {PreFooterProps} props The pre footer properties object
 * */
export const styles = (props: PreFooterProps) => css`
    ${baseStyles(props)}
`;
